import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { refreshRequest, pingRequest } from '@defi/core-auth';
import Auth from '@defi/core-auth'; //import Token from '../../utils/token';

import { PATH_DASHBOARD, REQUIRE_AUTH } from '@defi/core-constants';
export default function (ComposedComponent) {
  var editOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var ignorePermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var AppContext = arguments.length > 3 ? arguments[3] : undefined;

  function checkExpiration() {
    // Get expiration and current timestamp
    var refreshTimeStamp = localStorage.refresh ? Number(localStorage.refresh) : 0;
    var currentTime = new Date().getTime();
    var currentTimeStamp = Math.floor(currentTime / 1000);
    return currentTimeStamp > refreshTimeStamp;
  }

  var Authentication =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Authentication, _React$Component);

    function Authentication(props) {
      var _this;

      _classCallCheck(this, Authentication);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Authentication).call(this, props));

      if (REQUIRE_AUTH) {
        // Verify all permissions and fields
        var authorized = Auth.verification(window.location.pathname, editOnly, ignorePermissions);

        if (!authorized) {
          window.location.replace(PATH_DASHBOARD);
        } // Check for expiration running low


        if (checkExpiration()) {
          _this.props.dispatch(refreshRequest());
        } // Run a ping to check user cookies


        props.dispatch(pingRequest());
      }

      return _this;
    }

    _createClass(Authentication, [{
      key: "render",
      value: function render() {
        return React.createElement(ComposedComponent, Object.assign({
          context: AppContext
        }, this.props));
      }
    }]);

    return Authentication;
  }(React.Component);

  Authentication.contextTypes = {
    router: object
  };
  return connect()(Authentication);
}